export const errorMsg = (state, data) => {
  state.errorMsg = data
}

export const setupPasswordError = (state, data) => {
  state.setupPasswordError = data
}

export const validateCode = (state, data) => {
  state.validateCode = data
}